import { create } from "zustand";

type State = {
  post: string;
};

type Action = {
  setPost: (trigger: string) => void;
};

const usePost = create<State & Action>((set) => ({
  post: "",
  setPost: (newPost) => set(() => ({ post: newPost })),
}));

export default usePost;
